import { ApprovalFlows } from '@mint-sdk/api-approval-flows';

const useSendApprovalRequestMutation = () => {
  return ApprovalFlows.createRequest();
};

export default useSendApprovalRequestMutation;
